var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("transition", { attrs: { name: "fade" } }, [
    _c("div", { staticClass: "preloader-offer" }, [
      _c("div", { staticClass: "img" }, [
        _c("img", { attrs: { src: "/img/icon/preloader.gif", alt: "" } })
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }